export default "__VITE_ASSET__DBSqxp6j__"